export default {"src":"/_next/static/media/man-waving.colour.9270e69b.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};